module.exports = __webpack_public_path__ + "static/media/logo-derdic.21f5f7a6.png";